export class Global {
    static ENDPOINT = {
        BASE: 'https://laserando-api.oddacoding.net',
        // TEST: 'http://localhost:8100'
    }
}
